// extracted by mini-css-extract-plugin
export default {"container":"Day_container__DJSRM","dayIndicator":"Day_dayIndicator__tysce"};